/**
 * SEO metadata resolution rules (from the taxonomy workbook's "Metadata
 * Rules" sheet). Per-category Page Title / H1 / Meta Description templates
 * live directly on each src/config/seo/seoCategories.js entry (the sheet
 * already had specific, approved copy per row) — this module only resolves
 * what `{{LOCATION}}` should be replaced with, plus a generic fallback
 * template for the rare row missing its own.
 */

// SOW: "For the category-only/base URL, use Sewawin's current overall
// active service area." Not a fixed value in the source docs — update this
// one constant if the marketplace's overall service area changes; canonical
// category URLs themselves don't change (see Metadata Rules "Important"
// notes).
export const OVERALL_SERVICE_AREA_LABEL = 'Indonesia';

/**
 * Resolves the {{LOCATION}} value for a given page scope.
 * @param {'category-only'|'locL1'|'locL2'} scope
 * @param {string} [locationLabel] required for 'locL1'/'locL2' — the
 *   resolved location's display label (e.g. 'Jakarta', 'Jakarta Selatan').
 */
export const resolveLocationLabel = (scope, locationLabel) => {
  if (scope === 'category-only') return OVERALL_SERVICE_AREA_LABEL;
  if (!locationLabel) {
    throw new Error(`resolveLocationLabel: locationLabel is required for scope "${scope}"`);
  }
  return locationLabel;
};

// Generic fallback templates (identical across all page types per the
// Metadata Rules sheet) — only used if a seoCategories.js entry somehow
// lacks its own template.
export const genericTemplates = {
  pageTitleTemplate: '{{PRIMARY_KEYWORD}} di {{LOCATION}} | Sewawin',
  h1Template: '{{PRIMARY_KEYWORD}} di {{LOCATION}}',
  metaDescriptionTemplate:
    'Temukan {{PRIMARY_KEYWORD}} di {{LOCATION}} melalui Sewawin. Bandingkan pilihan, harga, dan penyedia sesuai kebutuhan Anda.',
};

export default { OVERALL_SERVICE_AREA_LABEL, resolveLocationLabel, genericTemplates };
